import { render, staticRenderFns } from "./BoxStory.vue?vue&type=template&id=5118e0cd&"
import script from "./BoxStory.vue?vue&type=script&lang=js&"
export * from "./BoxStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports